<template>
  <div class="sidebar">
    <!-- <div class="system-name">{{`喜马拉雅${promotorType==1?'城市合伙人':'分销商'}后台`}}</div> -->
    <div class="system-name">喜马城市服务商智能管理系统</div>
    <el-menu :unique-opened='true' mode="vertical"  :default-active="$route.path">
      <router-link :to="item.path" :key="item.text"  v-for="item in permission_routers" v-if="!item.hidden && !(item.path=='/data/center' && !isPromotorDisplay)">
        <el-menu-item :index="item.text"><div :class="`icon-img ${item.icon}`"></div>{{item.text}}</el-menu-item>
      </router-link>
    </el-menu>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

    export default {
      name: 'Sidebar',
      computed: {
        ...mapGetters([
          'permission_routers',
          'promotorType',
          'isPromotorDisplay'
        ])
      },
      mounted(){
      }
    }
</script>

<style lang="scss" scoped>
.sidebar{
  position: absolute;
  width: 160px;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  display: block;
  padding: 0px;
  overflow-x: hidden;
  overflow-y: auto;
  text-align: center;
  a{
    &.router-link-active{
      color:#fff;
      background-color:#428bca;
    }
  }
  .system-name{
    height:50px;
    line-height: 50px;
    font-size: 14px;
    background-color: #f66549;
    color: #fff;
    margin-bottom: 20px;
  }
  .icon-img{
    width: 14px;
    height:14px;
    background-size: 100% 100%;
    margin-right: 10px;
    display:inline-block;
    
    &.icon-shop{
      background-image: url(~assets/shop.png);
    }
    &.icon-goods{
      background-image: url(~assets/goods.png);
    }
    &.icon-distributor{
      background-image: url(~assets/distributor.png);
    }
    &.icon-order{
      background-image: url(~assets/order.png);
    }
    &.icon-profile{
      background-image: url(~assets/profile.png);
    }
    &.icon-rank{
      background-image: url(~assets/rank.png);
    }
    &.icon-notice{
      background-image: url(~assets/partnerNotice.png);
    }
    
  }
  .router-link-active, .el-menu-item:hover{
    .icon-shop{
      background-image: url(~assets/shop-on.png);
    }
    .icon-goods{
      background-image: url(~assets/goods-on.png);
    }
    .icon-distributor{
      background-image: url(~assets/distributor-on.png);
    }
    .icon-order{
      background-image: url(~assets/order-on.png);
    }
    .icon-profile{
      background-image: url(~assets/profile-on.png);
    }
    .icon-rank{
      background-image: url(~assets/rank-on.png);
    }
    .icon-notice{
      background-image: url(~assets/partnerNotice-on.png);
    }
  }

  .el-menu-item{
    display: flex;
    align-items: center;
  }

}
</style>





// WEBPACK FOOTER //
// Sidebar.vue?cf9e08c6